'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

var _constants = require('./constants');

var doNotIndexIfPageIsGTConstant = function doNotIndexIfPageIsGTConstant(page) {
  return parseInt(page, 10) <= _constants.INDEX_UPTO_PAGE ? 'index,follow' : 'noindex,follow';
};

var allowedSingleKeys = ['worktype', 'classification', 'subclassification'];

var disallowedKeys = ['companyid', 'location', 'area', 'areaid', 'state', 'nation'];

var haveValue = function haveValue(query) {
  return function (prop) {
    return typeof query[prop] === 'string' && query[prop].length > 0;
  };
};

var getValue = function getValue(query) {
  return function (prop) {
    return query[prop];
  };
};

var keysValueIsNotSingular = function keysValueIsNotSingular(value) {
  return value.indexOf(',') > -1;
};

var allowedSingleKeysIncludes = function allowedSingleKeysIncludes(value) {
  return allowedSingleKeys.indexOf(value) > -1;
};

var keysHaveMultipleValues = function keysHaveMultipleValues(query) {
  return Object.keys(query).filter(allowedSingleKeysIncludes).map(getValue(query)).map(keysValueIsNotSingular);
};

var shouldBeIndexed = function shouldBeIndexed(query) {
  return !Boolean([].concat(_toConsumableArray(disallowedKeys.map(haveValue(query))), _toConsumableArray(keysHaveMultipleValues(query))).filter(function (v) {
    return v;
  }).length);
};

exports['default'] = function (query) {
  return shouldBeIndexed(query) ? doNotIndexIfPageIsGTConstant(query.page || '0') : 'noindex,nofollow';
};

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-seo/build/should-index-page.js
 ** module id = 558
 ** module chunks = 0
 **/